import { AGENCY_SHIFTS_FETCH_BEGIN } from './action-types'

export const fetchAgencyShifts = ({ options }: { options: Record<string, any> }) => ({
  type: AGENCY_SHIFTS_FETCH_BEGIN,
  options,
})
export type FetchAgencyShiftsAction = ReturnType<typeof fetchAgencyShifts>

export type AgencyShiftsAction = FetchAgencyShiftsAction
